const Community = () => {

    return (
        <h1 className="btn-default">Join NOw</h1>
    );
};

export default Community;